var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-width",style:({
		'height': _vm.height + 'px',
		'background-color': _vm.color,
		'border-radius': _vm.borderRadius + 'px'
	})})}
var staticRenderFns = []

export { render, staticRenderFns }